import { render, staticRenderFns } from "./AttributesTab.vue?vue&type=template&id=15b4b687"
import script from "./AttributesTab.vue?vue&type=script&lang=js"
export * from "./AttributesTab.vue?vue&type=script&lang=js"
import style0 from "./AttributesTab.vue?vue&type=style&index=0&id=15b4b687&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports